import React from 'react';
import './Privacy.css';

function Privacy() {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1>AVIS DE CONFIDENTIALITÉ</h1>
        <h2>Personal Regrets</h2>
        <p className="last-updated">Dernière mise à jour : Le 2 janvier 2026</p>

        <section>
          <h3>1. Portée du présent avis de confidentialité</h3>
          <p>
            Le présent avis de confidentialité explique comment Personal Regrets collecte, utilise et
            protège vos données personnelles lorsque vous interagissez avec nous, notamment dans
            les situations suivantes :
          </p>
          <ul>
            <li>achat d'un produit sur notre site internet ;</li>
            <li>navigation sur notre site ;</li>
            <li>inscription à nos communications marketing (le cas échéant) ;</li>
            <li>participation à des opérations promotionnelles organisées par Personal Regrets ;</li>
            <li>prise de contact avec nous (email, formulaire de contact) ;</li>
            <li>interaction avec nos contenus sur les réseaux sociaux.</li>
          </ul>
          <p>
            Cet avis s'applique uniquement aux traitements de données effectués par Personal Regrets
            dans le cadre de ses activités en ligne.
          </p>
        </section>

        <section>
          <h3>2. Qui est responsable du traitement ?</h3>
          <p>Le responsable du traitement des données personnelles est :</p>
          <p>
            Personal Regrets<br />
            Société par Actions Simplifiée (EA)<br />
            Immatriculée en France<br />
            Siège social : 3 rue Narcisse Fahy, 77515 Faremoutiers<br />
            SIRET : 79516211400024<br />
            Email : personalregrets@gmail.com.
          </p>
        </section>

        <section>
          <h3>3. Quelles données personnelles collectons-nous ?</h3>
          <p>
            Selon votre interaction avec nous, nous pouvons collecter les catégories de données
            suivantes :
          </p>

          <h4>3.1 Données d'identification</h4>
          <ul>
            <li>nom, prénom</li>
          </ul>

          <h4>3.2 Données de contact</h4>
          <ul>
            <li>adresse email</li>
            <li>adresse postale (livraison et facturation)</li>
          </ul>

          <h4>3.3 Données de commande</h4>
          <ul>
            <li>produits commandés</li>
            <li>tailles, quantités</li>
            <li>historique des achats</li>
            <li>informations liées au service client et aux retours</li>
          </ul>

          <h4>3.4 Données de paiement</h4>
          <p>
            Les paiements sont traités de manière sécurisée par notre prestataire Stripe.
            Personal Regrets n'a pas accès aux numéros complets de carte bancaire.
          </p>

          <h4>3.5 Données techniques</h4>
          <ul>
            <li>adresse IP</li>
            <li>données de navigation</li>
            <li>informations relatives à l'appareil et au navigateur (à des fins de sécurité et de
            fonctionnement du site)</li>
          </ul>
        </section>

        <section>
          <h3>4. Pourquoi utilisons-nous vos données (finalités et bases légales) ?</h3>
          <p>Vos données personnelles sont traitées pour les finalités suivantes :</p>

          <h4>4.1 Exécution du contrat</h4>
          <ul>
            <li>gestion des commandes</li>
            <li>paiement</li>
            <li>livraison</li>
            <li>retours et remboursements</li>
          </ul>
          <p><em>Base légale : exécution du contrat (article 6.1.b du RGPD)</em></p>

          <h4>4.2 Obligations légales</h4>
          <ul>
            <li>facturation</li>
            <li>obligations comptables et fiscales</li>
          </ul>
          <p><em>Base légale : obligation légale (article 6.1.c du RGPD)</em></p>

          <h4>4.3 Intérêt légitime</h4>
          <ul>
            <li>sécurité du site</li>
            <li>prévention de la fraude</li>
            <li>amélioration du service client</li>
          </ul>
          <p><em>Base légale : intérêt légitime (article 6.1.f du RGPD)</em></p>

          <h4>4.4 Communications marketing (le cas échéant)</h4>
          <ul>
            <li>envoi d'emails promotionnels uniquement si vous y avez consenti</li>
          </ul>
          <p><em>Base légale : consentement (article 6.1.a du RGPD)</em></p>
        </section>

        <section>
          <h3>5. Avec qui partageons-nous vos données ?</h3>
          <p>Nous partageons vos données uniquement lorsque cela est nécessaire, avec :</p>
          <ul>
            <li><strong>Stripe</strong> : prestataire de paiement sécurisé</li>
            <li><strong>prestataires de livraison</strong> : La Poste</li>
            <li><strong>hébergeur du site</strong> : OVH CLOUD</li>
          </ul>
          <p>Ces prestataires agissent en qualité de sous-traitants au sens du RGPD.</p>
        </section>

        <section>
          <h3>6. Transferts de données hors Union européenne</h3>
          <p>
            Certains de nos prestataires (notamment Stripe) peuvent traiter des données en dehors de
            l'Union européenne.
            Dans ce cas, des garanties appropriées sont mises en place conformément au RGPD
            (clauses contractuelles types, mesures de sécurité adaptées).
          </p>
        </section>

        <section>
          <h3>7. Combien de temps conservons-nous vos données ?</h3>
          <p>
            Les données sont conservées uniquement pendant la durée nécessaire aux finalités pour
            lesquelles elles ont été collectées, notamment :
          </p>
          <ul>
            <li>données de commande : durée de la relation commerciale, puis archivage légal ;</li>
            <li>données de facturation : selon les obligations légales en vigueur ;</li>
            <li>données marketing : jusqu'au retrait de votre consentement.</li>
          </ul>
        </section>

        <section>
          <h3>8. Vos droits</h3>
          <p>Conformément au RGPD, vous disposez des droits suivants :</p>
          <ul>
            <li>droit d'accès</li>
            <li>droit de rectification</li>
            <li>droit à l'effacement</li>
            <li>droit à la limitation du traitement</li>
            <li>droit d'opposition</li>
            <li>droit à la portabilité (dans les cas prévus par la loi)</li>
          </ul>
          <p>
            Pour exercer vos droits, vous pouvez nous contacter à :<br />
            personalregrets@gmail.com
          </p>
          <p>
            Vous disposez également du droit d'introduire une réclamation auprès de la CNIL
            (www.cnil.fr).
          </p>
        </section>

        <section>
          <h3>9. Modifications de l'avis de confidentialité</h3>
          <p>
            Nous pouvons modifier le présent avis de confidentialité à tout moment afin de refléter les
            évolutions légales ou de nos pratiques.
            La version en vigueur est celle publiée sur le site à la date de votre navigation.
          </p>
        </section>

        <section className="legal-references">
          <h3>Sources juridiques officielles (vérifiables)</h3>
          <ul>
            <li>
              <strong>Règlement (UE) 2016/679 – RGPD</strong><br />
              Parlement européen<br />
              <a href="https://eur-lex.europa.eu/eli/reg/2016/679/oj" target="_blank" rel="noopener noreferrer">
                https://eur-lex.europa.eu/eli/reg/2016/679/oj
              </a>
            </li>
            <li>
              <strong>CNIL – Données personnelles et e-commerce (2024)</strong><br />
              <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">
                https://www.cnil.fr
              </a>
            </li>
            <li>
              <strong>Code de la consommation – Vente à distance</strong><br />
              <a href="https://www.legifrance.gouv.fr" target="_blank" rel="noopener noreferrer">
                https://www.legifrance.gouv.fr
              </a>
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default Privacy;
